import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// MUI X pickers need the utc and timezone plugins for their `timezone` prop. dayjs is used only as
// the picker adapter; formatting everywhere else goes through Intl.DateTimeFormat (lib/dates.ts).
dayjs.extend(utc);
dayjs.extend(timezone);

export { dayjs };
export type { Dayjs } from 'dayjs';
